import React from 'react';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  spotsLeft?: number;
};
export function ScarcityBar({
  spotsLeft = 7
}: ScarcityBarProps) {
  return <div className="w-full max-w-md mx-auto" data-id="element-197" data-mp="2l4xt8va3uama">
      <div className="flex items-center justify-between mb-2" data-id="element-198" data-mp="2l44uaghe0pep">
        <span className="flex items-center gap-1.5 text-[#7c6aa8] text-xs font-semibold uppercase tracking-wide" data-id="element-199" data-mp="2q3r9gvgs0fq5">
          <FlameIcon className="w-4 h-4 text-[#b99a63]" data-id="element-200" data-mp="2b6gydn81pbuy" />
          Precio promocional
        </span>
        <span className="text-[#3b3350] text-xs font-bold" data-id="element-201" data-mp="2g63blwnvis3r">
          Quedan {spotsLeft} cupos
        </span>
      </div>
      <div className="relative h-3.5 w-full rounded-full bg-[#e4dbcc] overflow-hidden" data-id="element-202" data-mp="227dcycleokda">
        <div className="shimmer-bar relative h-full rounded-full bg-gradient-to-r from-[#a99bc9] to-[#7c6aa8] overflow-hidden" style={{
        width: '92%'
      }} data-id="element-203" data-mp="2766fj9z5mqyo" />
      </div>
      <p className="text-center text-[11px] text-[#8a8296] mt-2" data-id="element-204" data-mp="5e1r48gv6bsp">
        92% de los cupos con descuento ya fueron reclamados
      </p>
    </div>;
}